export enum PAYMENT_METHOD {
    REGULAR = 1,
    CREDIT_CARD = 2,
    BEHALF = 3,
    TOKEN = 5,
    BALANCE = 6
}
